
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"width":"8","height":"1.38","x":"8","y":"6.6","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('rect',{attrs:{"width":"8","height":"1.38","x":"8","y":"9.6","fill":"#00DCF7","fill-rule":"nonzero","rx":".34"}}),_c('path',{attrs:{"stroke":"#000","stroke-linejoin":"round","d":"M22 9.06V8.6l-8.681 6.577a2.3 2.3 0 01-2.638 0L2 9.1v-.5 11.54a1.96 1.96 0 001.96 1.96h16.08A1.96 1.96 0 0022 20.14V9.06h0z"}}),_c('path',{attrs:{"stroke":"#000","d":"M17.252 4.1c.965 0 1.748.755 1.748 1.685V11.2l-5.681 3.977a2.3 2.3 0 01-2.638 0L5 11.2V5.785c0-.93.783-1.685 1.748-1.685h10.504z"}}),_c('path',{attrs:{"fill":"#FAB4CD","stroke":"#000","d":"M19 6.172l2.422 1.575c.36.234.578.635.578 1.064 0 .428-.224.824-.59 1.043L19 11.3V6.172zM5 6.171v4.779L2.368 9.24a.809.809 0 010-1.357L5 6.171zm8.068-3.854l2.779 1.805H8.153l2.779-1.805a1.96 1.96 0 012.136 0z"}})])])
          )
        }
      }
    